/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Face_Card_TitleInputs */

const vi_face_card_title = /** @type {(inputs: Face_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận diện khuôn mặt`)
};

/**

* @param {Face_Card_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const face_card_title = /** @type {((inputs?: Face_Card_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Face_Card_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_face_card_title(inputs)
});